import type { TFunction } from "i18next";
import type { Schema } from "@/shared/components/Form/types";

export function makeDomainSettingsSchema(t: TFunction): Schema {
  return {
    host: {
      type: "text",
      label: t("domainSettings.form.hostLabel"),
      required: true,
      xs: 12,
      fullWidth: true,
    },
  };
}
